(function () {
  'use strict';

  var STYLE_ID = 'pawprint-scroll-reveal-styles';
  var ITEM_CLASS = 'paw-scroll-reveal';
  var VISIBLE_CLASS = 'is-paw-revealed';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media (prefers-reduced-motion: no-preference) {',
      '  .paw-scroll-reveal {',
      '    opacity: 0;',
      '    transform: translate3d(0, 26px, 0);',
      '    transition: opacity 680ms cubic-bezier(.22,1,.36,1), transform 680ms cubic-bezier(.22,1,.36,1);',
      '    transition-delay: var(--paw-reveal-delay, 0ms);',
      '    will-change: opacity, transform;',
      '  }',
      '  .paw-scroll-reveal.is-paw-revealed {',
      '    opacity: 1;',
      '    transform: translate3d(0, 0, 0);',
      '    will-change: auto;',
      '  }',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  .paw-scroll-reveal { opacity: 1 !important; transform: none !important; transition: none !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function revealImmediately(items) {
    items.forEach(function (item) {
      item.classList.add(VISIBLE_CLASS);
    });
  }

  function prepareGroup(group, selectors) {
    if (!group || group.dataset.pawRevealReady === 'true') return;

    var items = [];
    selectors.forEach(function (selector) {
      group.querySelectorAll(selector).forEach(function (item) {
        if (items.indexOf(item) === -1) items.push(item);
      });
    });
    if (!items.length) return;

    group.dataset.pawRevealReady = 'true';
    items.forEach(function (item, index) {
      item.classList.add(ITEM_CLASS);
      item.style.setProperty('--paw-reveal-delay', (index * 135) + 'ms');
    });

    if (REDUCED_MOTION.matches || !('IntersectionObserver' in window)) {
      revealImmediately(items);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealImmediately(items);
        observer.disconnect();
      });
    }, {
      root: null,
      rootMargin: '0px 0px -34% 0px',
      threshold: 0.12
    });

    observer.observe(group);
  }

  function initialize(scope) {
    installStyles();
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('.paw-story__promise').forEach(function (group) {
      prepareGroup(group, ['article']);
    });

    root.querySelectorAll('.paw-story__faq').forEach(function (group) {
      prepareGroup(group, [
        '.paw-story__faq-title > *',
        '.paw-story__faq-list > details'
      ]);
    });
  }

  function start() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();